import { Loom } from "components/videos/Loom";
import { Video } from "components/videos/Video";
import { FaqDto } from "dtos/content/FaqDto";
import { ReactNode } from "react";

const AccordionItem = (props: {
    index: number;
    title: string;
    description: ReactNode;
    parent: string;
    loomId?: string;
    youTubeId?: string;
    whiteBg?: boolean;
}) => {
    const { index, title, description, parent, loomId, youTubeId, whiteBg } = props;

    const id = `${parent}-${index}`;

    return (
        <div className={`accordion-item${whiteBg ? " accordion-item--white-bg" : ""}`}>
            <h3 className="accordion-header">
                <button
                    type="button"
                    className="accordion-button collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target={`#${id}`}
                >
                    {title}
                </button>
            </h3>

            <div id={id} className="accordion-collapse collapse" data-bs-parent={`#${parent}`}>
                <div className="accordion-body">
                    <div className="vstack gap-3">
                        {description}

                        {loomId && <Loom id={loomId} />}
                        {youTubeId && <Video id={youTubeId} />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const Accordion = (props: {
    id: string;
    items: Array<{ title: string; description: ReactNode; youTubeId?: string; loomId?: string }>;
    whiteBg?: boolean;
}) => {
    const { id, items, whiteBg } = props;

    return (
        <div className="accordion" id={id}>
            {items.map(({ description, title, loomId, youTubeId }, index) => (
                <AccordionItem
                    key={index}
                    index={index}
                    title={title}
                    description={description}
                    parent={id}
                    loomId={loomId}
                    youTubeId={youTubeId}
                    whiteBg={whiteBg}
                />
            ))}
        </div>
    );
};

export const FaqAccordion = (props: { id: string; items: Array<FaqDto>; whiteBg?: boolean }) => {
    const { id, items, whiteBg } = props;

    return (
        <Accordion
            id={id}
            whiteBg={whiteBg}
            items={items.map(d => ({
                title: d.name,
                description: <div className="vstack gap-3 content-page" dangerouslySetInnerHTML={{ __html: d.body }} />,
                loomId: d.loomId,
                youTubeId: d.youTubeId,
            }))}
        />
    );
};
